import { LOAD_GRADE_LEVEL_MESSAGES } from '@/core/values/app.values';
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({})
export default class EdFilterTemplateComponent extends Vue {
  
  filterSelected = null;
  
  get filterGradesOptions() {
    return this.$store.state.CourseTemplateStore.templatesGradeLevelsOptions.map(opt => {
      if (opt.text.toLowerCase() === 'see all') {
        return { ...opt, value: 'all' };
      }
      return opt;
    });
  }  

  get organizationId() {
    return this.$store.state.ToolsStore.institutionInfo.length > 0 
      ? this.$store.state.ToolsStore.institutionInfo[0].organizationId : null;
  }

  setGradeLevelSelected() {
    const valueToSend = this.filterSelected === 'all' ? '' : this.filterSelected;
    this.$CourseTemplates.Store.setGradeLevelSelected(valueToSend);
  }

  getGradeLevels() {
    this.$CourseTemplates.Store.getGradeLevels(this.organizationId);
  }

  mounted() {
    this.filterSelected = this.$store.state.CourseTemplateStore.templatesGradeLevelSelected === '' ? 'all' : null;
    if(!this.filterGradesOptions || this.filterGradesOptions.length <= 0) {
      this.getGradeLevels();
    }
    this.$edEventBus.$on(LOAD_GRADE_LEVEL_MESSAGES, this.getGradeLevels);
  }

  beforeDestroy() {
    this.$edEventBus.$off(LOAD_GRADE_LEVEL_MESSAGES, this.getGradeLevels);
  }

}